import React, { useState } from "react";
import MeetTheFirm from "../component/AboutPage/MeetTheFirm";
import MeetTheTeam from "../component/AboutPage/MeetTheTeam";
import AwardsAbout from "../component/AboutPage/AwardsAbout";
import { motion, AnimatePresence } from "framer-motion";

export default function AboutPage() {
  const tabs = ["Meet The Firm", "Meet Our Team"];
  const [selectedTab, setSelectedTab] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  return (
    <div className="md:mt-[8%] mt-[30%] w-full flex flex-col md:flex-row max-w-7xl mx-auto px-4 md:px-8 gap-6">
      {/* Desktop View - Sidebar Tabs */}
      <div className="hidden md:flex flex-col w-[20%] bg-gray-100 p-4 rounded-lg shadow-lg">
        <h3 className="text-lg font-bold text-[#0F172A] mb-3">About Us</h3>
        <div className="flex flex-col space-y-2">
          {tabs.map((tab, index) => (
            <motion.button
              key={index}
              onClick={() => setSelectedTab(index)}
              whileHover={{ scale: 1.05 }}
              className={`text-left px-3 py-2 rounded-md font-semibold transition duration-300 ${
                selectedTab === index
                  ? "bg-[#C9A227] text-[#0F172A] shadow-md"
                  : "bg-white text-gray-700 border border-gray-300 hover:bg-gray-200"
              }`}
            >
              {tab}
            </motion.button>
          ))}
        </div>
      </div>

      {/* Mobile View - Dropdown */}
      <div className="md:hidden w-full">
        <div className="relative">
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="w-full bg-gray-100 px-4 py-2 text-left rounded-lg border border-gray-300 text-gray-700 font-semibold flex justify-between items-center"
          >
            {tabs[selectedTab]}
            <span>{isDropdownOpen ? "▲" : "▼"}</span>
          </button>
          {isDropdownOpen && (
            <motion.div
              className="absolute w-full mt-2 bg-white border border-gray-300 rounded-lg shadow-lg z-10"
              initial={{ opacity: 0, y: -5 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            >
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => {
                    setSelectedTab(index);
                    setIsDropdownOpen(false);
                  }}
                  className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-200 transition duration-300"
                >
                  {tab}
                </button>
              ))}
            </motion.div>
          )}
        </div>
      </div>

      {/* Content Section (80% Width on Desktop) */}
      <div className="w-full md:w-[80%] bg-white p-6 md:p-8 rounded-lg shadow-lg border border-gray-200">
        <AnimatePresence mode="wait">
          <motion.div
            key={selectedTab}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5 }}
          >
            {selectedTab === 0 && <MeetTheFirm />}
            {selectedTab === 1 && <MeetTheTeam />}
            {selectedTab === 2 && <AwardsAbout />}
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
